import { DeprecatedThemeOptions, ThemeOptions } from '@mui/material'
import { useCallback } from 'react'
import { EmbeddedRh24MessageTypes } from './EmbeddedRh24MessageTypes'

/**
 * Message payloads for the embedded messages. Ideally should be defined in a shared
 * location, but for now must be defined here and in the webapp SDK
 */
interface MessagePayloads {
  [EmbeddedRh24MessageTypes.RH24_EMBEDDED_SETUP]: {
    theme?: DeprecatedThemeOptions
    themeV5?: ThemeOptions
    partyId: string
    parentTitle?: string
    parentHref?: string
  }
  [EmbeddedRh24MessageTypes.RH24_EMBEDDED_SEARCH_PARAMS_CHANGED]: {
    queryString: string
  }
}

/**
 * Custom hook to send messages to the parent window in an embedded context.
 * This is used to communicate with the webapp SDK.
 * @returns sendMessage function to send messages to the parent window, to be handled
 * by the webapp sdk
 */
export const useCustomerPortalMessages = () => {
  // Generic function that enforces type safety based on the message type
  const sendMessage = useCallback(
    <T extends EmbeddedRh24MessageTypes>(
      embeddedMessageType: T,
      payload: MessagePayloads[T],
    ) => {
      window.parent?.postMessage(
        {
          type: embeddedMessageType,
          payload: payload,
        },
        '*',
      )
    },
    [],
  )

  return {
    sendMessage,
  }
}
